import { Component, Input, forwardRef, Optional, Host, SkipSelf, OnInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ControlContainer, AbstractControl, FormsModule } from '@angular/forms';
import { NgClass, NgIf } from '@angular/common';
import { NgxIntlTelInputModule } from 'untold-ngx-intl-tel-input';

@Component({
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextInputComponent),
            multi: true
        }],
    imports: [NgClass, NgIf, FormsModule, NgxIntlTelInputModule],
    standalone: true
})
export class TextInputComponent implements ControlValueAccessor, OnInit {

  @Input() label;
  @Input() autocomplete = 'on';
  @Input() requiredMark = false;
  @Input() mask = false;
  @Input() tabId = 0;
  @Input() placeholder;
  @Input() invalidMsg = 'Invalid field';
  @Input() inputType = 'text';
  @Input() submitAttempted = false;
  @Input() formControlName: string;
  @Input() hasMarginB = true;
  @Input() inputClasses = '';
  @Input() prefix = null;
  @Input() suffix = null;
  @Output() blur = new EventEmitter;

  public model;
  public currentControl: AbstractControl;
  public _value = '';
  public propagateChange: any = () => {};

  constructor(@Optional() @Host() @SkipSelf()
    private controlContainer: ControlContainer) {
  }


  ngOnInit() {
    if (this.controlContainer) {
      this.currentControl = this.controlContainer.control.get(this.formControlName);
      this.model = this.currentControl.value;
    }

  }

  onBlur($event) {
    this.blur.emit($event);
  }

  writeValue(value: any) {
    if (typeof value === 'string') {
     this._value = value;
     this.model = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: () => void): void { }

  onChange(event) {
    this.propagateChange(event.target.value);
  }

  hasValidationError() {
    if (this.currentControl) {
      return this.currentControl.invalid && this.submitAttempted;
    } else {
      return this.invalidMsg;
    }
  }

}
